<template>
    <div class="form__item">
        <label :for="id">
            <slot name="label"></slot>
            <span v-if="required == true" style="color: red;">*</span>
        </label>
        
        <span v-if="$slots.error" class="input__error">
            <i class="fas fa-exclamation-triangle"></i> <slot name="error"></slot>
        </span>
        
        <input v-model="inputValue" v-if="type == 'number'" :id="id" :type="type" step="1" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="number"  :disabled="disabled" :required="required" ref='input'>
        
        <span v-else-if="type == 'currency'" class="input__currency--container">
            <span class="input__currency--symbol">£</span>
            <input v-model="inputValue" class="input__currency" :id="id" type="number" min="0.00" step="1" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="currency"  :disabled="disabled" :required="required" ref='input'>
        </span>
        
        <textarea v-model="inputValue" v-else-if="type == 'textarea'" :name="id" :id="id" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="text"  :disabled="disabled" :required="required" ref='input'></textarea>

        <input v-model="inputValue" v-else :id="id" :type="type" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="text"  :disabled="disabled" :required="required" ref='input'>
    </div>
</template>

<script>
export default {
    props: {
        id: { type: String, default: null },
        email: { type: Boolean, default: false },
        password: { type: Boolean, default: false },
        textarea: { type: Boolean, default: false },
        number: { type: Boolean, default: false },
        currency: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        placeholder: { type: String, default: '' },
        autofocus: { type: Boolean, default: false },
        disabled: {type: Boolean, default: false},
        value: {
            validator: prop => ['string', 'number'].includes(typeof prop) || prop === null,
            default: null
        },
    },
    computed: {
        inputValue: {
            get () {
                return this.value
            },
            set (value) {
                this.emitValue(value)
            }
        },
        type () {
            const { email, password, number, currency, textarea } = this
            
            return [
                ...(email ? [`email`] : password ? [`password`] : number ? [`number`] : currency ? [`currency`] : textarea ? [`textarea`] : [`text`]),
            ]
        },
    },
    methods: {
        emitValue (value) {
            if(this.number == true || this.currency == true){
                if(value == ''){
                    value = 0;
                }
                value = parseFloat(value);
            }
            this.$emit('input', value)
        },  
    },
    mounted() {
        this.autofocus ? this.$refs.input.focus() : ''
    }
}
</script>